import AccidentTravailType from '@/generated/controls/accidentTravail/AccidentTravailType.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: AccidentTravailType
})

